<svelte:options customElement={{ tag: "bt-scorm-download", shadow: "none" }} />

<script lang="ts">
  import { eventBus } from '$shared/lib/eventBus';

  export let href: string = '';
  export let label: string = 'Download SCORM package';
  export let message: string = '';

  function handleClick() {
    if (message) eventBus.emit('flash-trigger', { message, type: 'notice' });
  }
</script>

<a
  {href}
  class="block p-2 text-sm text-neutral-700 rounded-md hover:bg-neutral-200"
  on:click={handleClick}
>
  {label}
</a>
